var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 2.25H14.25C15.2089 2.25013 16.1286 2.63041 16.8075 3.3075L19.1925 5.6925C19.8696 6.37144 20.2499 7.29114 20.25 8.25V18.75C20.25 19.5456 19.9339 20.3087 19.3713 20.8713C18.8087 21.4339 18.0456 21.75 17.25 21.75H6.75C5.95435 21.75 5.19129 21.4339 4.62868 20.8713C4.06607 20.3087 3.75 19.5456 3.75 18.75V5.25C3.75 4.45435 4.06607 3.69129 4.62868 3.12868C5.19129 2.56607 5.95435 2.25 6.75 2.25V2.25Z",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 6.75V2.25C15.2089 2.25013 16.1286 2.63041 16.8075 3.3075L19.1925 5.6925C19.8696 6.37144 20.2499 7.29114 20.25 8.25H15.75C15.3522 8.25 14.9706 8.09196 14.6893 7.81066C14.408 7.52936 14.25 7.14782 14.25 6.75Z",
    stroke: "#C0CDE2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportGrey);
export default __webpack_public_path__ + "static/media/Report  - Grey.b62902b59550b817ddd1c2f8dacc3179.svg";
export { ForwardRef as ReactComponent };